export const hideCelloReferralWidget = (): void => {
    const widget = document.getElementById('attribution-widget');
    if (widget) {
        widget.style.display = 'none';
    }
};
